export default __webpack_public_path__ + "static/media/react.6a44992c.svg";